export const lang = (key, curlang = 'x') => {

    if (curlang === 'x') {
        curlang = localStorage.getItem('language');
    }
    curlang = (curlang === undefined || curlang === null) ? 'en' : curlang
    if (words[key] === undefined || words[key][curlang] === undefined)
        return "";
    else
        return words[key][curlang];
}

const words = {
    title: {
        en: 'DPR Korea Tour',
        kp: '조선관광',
        cn: '朝鲜旅游',
        ru: 'Туризм в КНДР',
        jp: '朝鮮観光'
    },

    all: {
        en: 'All',
        kp: '전체',
        cn: '全体',
        ru: 'Обзор',
        jp: 'すべて'
    },
    image: {
        en: 'Photos',
        kp: '사진',
        cn: '相片',
        ru: 'Фото',
        jp: '写真'
    },
    video: {
        en: 'Videos',
        kp: '동영상',
        cn: '动画面',
        ru: 'Видеоданные',
        jp: '動画'
    },
    destination: {
        en: 'Tourist Regions',
        kp: '관광지구',
        cn: '旅游区',
        ru: 'Участок туризма',
        jp: '観光地区'
    },
    place: {
        en: 'Tourist Attractions',
        kp: '참관지',
        cn: '参观点',
        ru: 'Место посещения',
        jp: '参観地'
    },

    service: {
        en: 'Service Facilities',
        kp: '봉사시설',
        cn: '服务设施',
        ru: 'Сервисные сооружения',
        jp: 'サービス施設'
    },

    agency: {
        en: 'Travel Companies',
        kp: '려행사',
        cn: '旅行社',
        ru: 'Турагентство',
        jp: '観光旅行社'
    },

    news: {
        en: 'News',
        kp: '최근소식',
        cn: '新闻',
        ru: 'Последние известия',
        jp: '最近のニュース'
    },
    special: {
        en: 'Tourist Gift',
        kp: '관광기념품',
        cn: '旅游纪念品',
        ru: 'Сувениры',
        jp: '観光記念品'
    },

    event: {
        en: 'Festivals and Other Events',
        kp: '축전 및 행사',
        cn: '庆典及仪式',
        ru: 'Фестиваль и мероприятия',
        jp: '祭典・行事'
    },

    experience: {
        en: 'Impressions',
        kp: '관광소감',
        cn: '旅游心得',
        ru: 'Впечатление у туристов',
        jp: 'インタビュー'
    },
    agency_news: {
        en: 'Tour services of a travel company',
        kp: '려행사 관광봉사',
        cn: '旅行社旅游服务',
        ru: 'Туристский сервис турагенства',
        jp: '旅行社の観光サービス'
    },
    folkways: {
        en: 'Korean Folklore',
        kp: '조선민속',
        cn: '朝鲜民俗',
        ru: 'Этнография Кореи',
        jp: '朝鮮民俗'
    },
    article: {
        en: 'Collection of photos',
        kp: '사진묶음',
        cn: '相片册',
        ru: 'Пачка фото',
        jp: '写真集'
    },
    input_search: {
        en: 'Input a keyword',
        kp: '검색어를 입력하십시오',
        cn: '请输入探索内容',
        ru: 'Найти',
        jp: '検索語を入力して下さい'
    },
    search: {
        en: 'Search',
        kp: '검색',
        cn: '探索',
        ru: 'Поиск',
        jp: '検索'
    },
    activity: {
        en: 'Special Tours',
        kp: '주제관광',
        cn: '主题旅游',
        ru: 'Тематический туризм',
        jp: 'テーマ別観光'
    },
    view_all: {
        en: 'All',
        kp: '전체 보기',
        cn: '概览',
        ru: 'Общий просмотр',
        jp: 'すべて'
    },

    other: {
        en: 'Others',
        kp: '기타',
        cn: '其他',
        ru: 'Прочее',
        jp: 'その他'
    },
    author_from: {
        en: 'Tourists from %country',
        kp: '%country 관광객',
        cn: '%country 游客',
        ru: '%country Турист',
        jp: '%country 観光客'
    },
    server_err: {
        en: 'Server Error',
        kp: '봉사기오유',
        cn: '服务机失误',
        ru: 'Ошибка сервисного аппарата',
        jp: 'サーバーミス'
    },
    total: {
        en: 'Total: ',
        kp: '검색건수: ',
        cn: '搜索次数: ',
        ru: 'Результаты поиска: ',
        jp: '搜索次数: '
    },
    search_key_err: {
        en: 'Invalid Search Key.',
        kp: '검색어를 정확히 입력하십시오.',
        cn: '探索内容失误',
        ru: 'Поиск Ошибка',
        jp: '検索語 ミス'
    },
    read_more: {
        en: 'To see more',
        kp: '상세보기',
        cn: '细看',
        ru: 'Для подробного просмотра',
        jp: '詳細'
    },
    address: {
        en: 'Add',
        kp: '주소',
        cn: '地址',
        ru: 'Адрес',
        jp: 'アドレス'
    },
    tel: {
        en: 'Tel',
        kp: '전화번호',
        cn: '电话',
        ru: 'Номер телефона',
        jp: '電話番号'
    },
    fax: {
        en: 'Fax',
        kp: '확스',
        cn: '传真',
        ru: 'Телефакс',
        jp: 'FAX'
    },
    email: {
        en: 'Email',
        kp: '전자우편',
        cn: '电邮',
        ru: 'Электронная почта',
        jp: 'Email'
    },

    pager_prev: {
        en: 'previous',
        kp: '이전',
        cn: '上一回',
        ru: 'Предыдущий',
        jp: '前'
    },
    pager_back: {
        en: 'List',
        kp: '목록',
        cn: '目录',
        ru: 'Список',
        jp: '目録'
    },
    pager_next: {
        en: 'Next',
        kp: '다음',
        cn: '下一回',
        ru: 'Следующий',
        jp: '次'
    },
    no_data: {
        en: 'There is no data.',
        kp: '자료가 없습니다.',
        cn: '无资料.',
        ru: 'Данные отсутствуют.',
        jp: '資料がありません'
    },
    introdution: {
        en: 'Outline',
        kp: '개  관',
        cn: '概  观',
        ru: 'Обзор',
        jp: '概  観'
    },
    we_have_err: {
        en: "Problem occurred.",
        kp: '문제가 발생하였습니다.',
        cn: '发生了问题',
        ru: 'Возникла проблема.',
        jp: '問題が発生しました'
    },
    not_exist_path: {
        en: 'The page you are searching does not exist.',
        kp: '당신이 찾고있는 페지가 존재하지 않습니다.',
        cn: '没有您要的页面',
        ru: 'Искомая страница не найдена.',
        jp: 'そのホームページは存在していません'
    },
    return_home: {
        en: 'Return home',
        kp: '첫페지로 돌아가기',
        cn: '回到第一页',
        ru: 'Перейти на 1-ю страницу',
        jp: '初頁へ戻す'
    },
    new: {
        en: 'New',
        kp: '새자료',
        cn: '新资料',
        ru: 'Новые данные',
        jp: '新しいデータ'
    },
    not_support: {
        en: 'Sorry, this homepage can be opened at over Chrome 50.0 and Firefox 45.0.',
        kp: '미안합니다. 이 싸이트는 Chorme 50.0이상, Firefox 45.0이상에서 열람가능합니다.',
        cn: '对不起，此网页可在Chrome 50.0以上、Firefox 45.0以上阅览。',
        ru: 'Извините, этот веб-сайт откроется в параметрах свыше Chrome 50.0 и Firefox 45.0.',
        jp: 'すみませんがこのホームページはChrome 50.0以上、Firefox 45.0以上でのみご覧いただけます。'
    },
    homepage: {
        en: 'Homepage',
        kp: '홈페지',
        cn: '网址',
        ru: 'веб-сайт',
        jp: 'ホームページ'
    }
}
